import Cleave from 'cleave.js/react';
import React, { memo } from 'react';
import { differenceInDays, endOfMonth } from 'date-fns';

export const CleaveCardCVV = memo((props: any) => {
  const { inputRef, ...rest } = props;
  return (
    <Cleave
      htmlRef={inputRef}
      options={{
        blocks: [4],
        numericOnly: true,
      }}
      {...rest}
    />
  );
});

export const CleaveCardNumber = memo((props: any) => {
  const { inputRef, onChange, ...rest } = props;
  return (
    <Cleave
      htmlRef={inputRef}
      options={{
        creditCard: true,
      }}
      onChange={(e: any) => {
        const {
          target: { rawValue: value },
        } = e;
        e.target.value = value;
        onChange(e);
      }}
      {...rest}
    />
  );
});

export const CleaveCardDate = memo((props: any) => {
  const { inputRef, ...rest } = props;
  return (
    <Cleave
      htmlRef={inputRef}
      options={{
        date: true,
        datePattern: ['m', 'y'],
      }}
      {...rest}
      placeholder={'MM/YY'}
    />
  );
});

export const CleaveNumber = memo((props: any) => {
  const { inputRef, onChange, ...rest } = props;
  return (
    <Cleave
      htmlRef={inputRef}
      options={{
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      }}
      onChange={(e: any) => {
        const {
          target: { rawValue: value },
        } = e;
        e.target.value = value;
        onChange(e);
      }}
      {...rest}
    />
  );
});

export const validateCardDate = (value: string) => {
  if (!value) return 'required';
  if (value.length < 5) return 'invalid-date';
  const [month, year] = value.split('/');
  let date = new Date(2000 + Number(year), Number(month) - 1);

  date = endOfMonth(date);

  if (differenceInDays(date, new Date()) < 0) return 'expired';
  return undefined;
};
